export const linksData = [
  {
    id: 0,
    href: "",
    sx: { mr: 1, pr: 1, borderRight: "2px solid" },
    text: "Terms",
  },
  {
    id: 1,
    href: "",
    sx: { mr: 1, pr: 1, borderRight: "2px solid" },
    text: "Policy",
  },
  {
    id: 2,
    href: "",
    sx: { mr: 1, pr: 1, borderRight: "2px solid" },
    text: "Cookie Policy",
  },
  {
    id: 3,
    href: "",
    sx: { mr: 1 },
    text: "Help Center",
  },
];
